import config from '../config';
const initialCommision = +process.env.REACT_APP_CUSTOMER_COMMISSION_PERCENTAGE;

export const getPriceWithComission = price => {
  return price + (price * initialCommision) / 100;
};
